<div *ngIf="showFormByUser==false">
  <div class="row">
    <div class="col-xxl-12 col-md-12 col-lg-12 col-sm-12 col-xs-12">
      <div class="text_header mt-5">
        <p class="text_headerr">Trámites Devueltos.</p>
        <p class="text_header">Licencia para prestación de servicios en Seguridad y Salud en el Trabajo.</p>
      </div>
    </div>
  </div>
</div>

<form [formGroup]="dateForm">
  <div class="row mt-3">
    <div class="col-xxl-3 col-md-3 col-lg-3 col-sm-12 col-xs-12">
      <div class="entradas-de-texto-govco">
        <label for="initial_date">Fecha inicial</label>
        <input class="search" id="initial_date" type="date" formControlName="initial_date"
               (click)="verificarFecha()"
               [ngClass]="{'error': isTouchedField(dateForm, 'initial_date') }"
        />
        <span *ngIf="!isValidField(dateForm, 'initial_date')"
              class="error-texto-govco alert-entradas-de-texto-govco" id="initial_date-note" role="alert"
              aria-live="assertive">
        {{ getErrorMessage('initial_date') }}
        </span>
      </div>
    </div>
    <div class="col-xxl-3 col-md-3 col-lg-3 col-sm-12 col-xs-12">
      <div class="entradas-de-texto-govco">
        <label for="initial_date">Fecha final</label>
        <input class="search" id="final_date" type="date" formControlName="final_date"
               (click)="verificarFecha()"
               [ngClass]="{'error': isTouchedField(dateForm, 'final_date') }"
        />
        <span *ngIf="!isValidField(dateForm, 'final_date')"
              class="error-texto-govco alert-entradas-de-texto-govco" id="final_date-note" role="alert"
              aria-live="assertive">
        {{ getErrorMessage('final_date') }}
        </span>
      </div>
    </div>
    <div class="col-xxl-3 col-md-3 col-lg-3 col-sm-12 col-xs-12">
      <div class="colum_filter_select">
        <select  class="form-select  search" aria-label="Default select
          example" formControlName="pageSize" (change)="changeDataTable()">
          <option *ngFor="let item of pageSizeOptions" [value]="item">Mostrar
            {{item}} registros</option>
        </select>
      </div>
    </div>
    <div class="col-xxl-3 col-md-3 col-lg-3 col-sm-12 col-xs-12">
      <div class="colum_filter_select">
        <div class="form-group type">
          <input style="padding: 8px;" type="text" class="form-control search" id="search" placeholder="Palabras claves" formControlName="textToSearch" />
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-xxl-3 col-md-3 col-lg-3 col-sm-12 col-xs-12">
      <div class="general_date_button">
        <button class="btn btn-success btn_search btn_block" (click)="changeDataTable()">Consultar <i class="fa-solid fa-magnifying-glass" style="margin-left: 5px;"></i></button>
      </div>
    </div>
  </div>
</form>

<div class="row">
  <div class="col-xxl-12 col-md-12 col-lg-12 col-sm-12 col-xs-12">
    <div class="alert_header mt-4">
      <div class="alert alert-success alert-dismissible fade show" role="alert">
        <strong>¡Apreciado Usuario!</strong>
        <p class="w-100 mt-3" style="font-size: 18px;">
          La consulta y el reporte de trámites que se han solicitado con su último estado de gestión,
          es por rango de fecha de acuerdo a la fecha del registro generada por el sistema.<br>
          Los trámites visualizados corresponden a los últimos 30 días desde la fecha actual.
        </p>
        <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
      </div>
    </div>
  </div>
</div>


<div class="row mt-4">
  <div class="col-xxl-12 col-md-12 col-lg-12 info_table">
      <div class="table-responsive">
          <table class="table" aria-describedby="mydesc">
              <thead>
                <tr>
                  <th>
                    <div class='filter-container header-container'>
                      <div class='header-text'>ID trámite</div>
                      <div class='icon-right'>
                        <span class="fa fa-sort-asc fa-lg sort-icon "(click)="sortAscDesNumber('id', 'up')"></span>
                        <span class="fa fa-sort-desc fa-lg sort-icon  "(click)="sortAscDesNumber('id', 'down')"></span>
                      </div>
                    </div>
                  </th>
                  <th>
                    <div class='filter-container header-container'>
                      <div class='header-text'>Identificación</div>
                      <div class='icon-right'>
                        <span class="fa fa-sort-asc fa-lg sort-icon "(click)="sortAscDesNumber('identificationNumber', 'up')"></span>
                        <span class="fa fa-sort-desc fa-lg sort-icon  "(click)="sortAscDesNumber('identificationNumber', 'down')"></span>
                      </div>
                    </div>
                  </th>
                  <th>
                    <div class='filter-container header-container'>
                      <div class='header-text'>Nombre</div>
                      <div class='icon-right'>
                        <span class="fa fa-sort-asc fa-lg sort-icon "(click)="sortAscDes('fullName', 'up')"></span>
                        <span class="fa fa-sort-desc fa-lg sort-icon  "(click)="sortAscDes('fullName', 'down')"></span>
                      </div>
                    </div>
                  </th>
                  <th>
                    <div class='filter-container header-container'>
                      <div class='header-text'>Tipo Trámite</div>
                      <div class='icon-right'>
                        <span class="fa fa-sort-asc fa-lg sort-icon "(click)="sortAscDes('process', 'up')"></span>
                        <span class="fa fa-sort-desc fa-lg sort-icon  "(click)="sortAscDes('process', 'down')"></span>
                      </div>
                    </div>
                  </th>
                  <th>
                    <div class='filter-container header-container'>
                      <div class='header-text'>Fecha radicación</div>
                      <div class='icon-right'>
                        <span class="fa fa-sort-asc fa-lg sort-icon "(click)="sortAscDesNumber('registrationDate', 'up')"></span>
                        <span class="fa fa-sort-desc fa-lg sort-icon  "(click)="sortAscDesNumber('registrationDate', 'down')"></span>
                      </div>
                    </div>
                  </th>
                  <th>
                    <div class='filter-container header-container'>
                      <div class='header-text'>Estado trámite</div>
                      <div class='icon-right'>
                        <span class="fa fa-sort-asc fa-lg sort-icon "(click)="sortAscDes('status', 'up')"></span>
                        <span class="fa fa-sort-desc fa-lg sort-icon  "(click)="sortAscDes('status', 'down')"></span>
                      </div>
                    </div>
                  </th>
                  <th>
                    <div class='filter-container header-container'>
                      <div class='header-text'>Fecha Estado</div>
                      <div class='icon-right'>
                        <span class="fa fa-sort-asc fa-lg sort-icon "(click)="sortAscDesNumber('dateTracking', 'up')"></span>
                        <span class="fa fa-sort-desc fa-lg sort-icon  "(click)="sortAscDesNumber('dateTracking', 'down')"></span>
                      </div>
                    </div>
                  </th>
                  <th>
                    <div class='filter-container header-container'>
                      <div class='header-text'>Tiempo de respuesta</div>
                      <div class='icon-right'>
                        <span class="fa fa-sort-asc fa-lg sort-icon "(click)="sortAscDesNumber('responseTime', 'up')"></span>
                        <span class="fa fa-sort-desc fa-lg sort-icon  "(click)="sortAscDesNumber('responseTime', 'down')"></span>
                      </div>
                    </div>
                  </th>
                  <th>
                    <div class='filter-container header-container'>
                      <div class='header-text'>Acciones</div>
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of tableFilter; let i= index ">
                  <td>{{item.filedNumber}}</td>
                  <td>{{item.identificationNumber}}</td>
                  <td>{{item.fullName}}</td>
                  <td>{{item.process}}</td>
                  <td>{{item.registrationDate | date: 'dd/MM/yyyy hh:mm a'}}</td>
                  <td>{{item.status}}</td>
                  <td>{{item.dateTracking | date: 'dd/MM/yyyy hh:mm a'}}</td>
                  <td>{{item.observation}}</td>
                  <td class="text-justify">
                    <a (click)="getTramiteActual(item.id)"><span class="govco-readme">Ver</span> </a>
                  </td>
                </tr>
              </tbody>
          </table>
      </div>
  </div>
</div>

<div class="row">
  <div class="col-lg-12 col-md-12 col-xxl-12">
    <div class="colum_paginator">
      <mat-paginator class="paginator" [hidePageSize]="true" [length]="registrotamanio"
                     [pageSize]="dateForm.get('pageSize').value" (page)="cambiarpagina($event)"> </mat-paginator>
    </div>
  </div>
</div>

<div class="row">
  <div class="col-sm-12 col-md-8">
    <app-info-tramite [tramiteActual]="tramiteSeleccionado" [isOnlyReadTramite]="true" *ngIf="showFormByUser==true"></app-info-tramite>
  </div>
</div>

<div *ngIf="showFormByUser==true">
  <br><br>
  <button type="button" class="btn-govco fill-btn-govco"
          style="margin-right: 10px"
          (click)="cancelFrm()">Volver
  </button>
</div>
<!--Bandeja-->
